import { Helmet } from "react-helmet-async";
import HelpDocHeader from "./HelpDocHeader";
import HelpData from "./HelpData";
import { Link } from "react-router-dom";

const Tutorial = () => {

    return (
        <div className="h-[700px] bg-gray-50 border-b border-b-primary/40">
            <Helmet>
                <title>Tutorial | MyCdir Documentation & Guides</title>
                <meta
                    name="description"
                    content="Explore MyCdir help guides and documentation for managing families, members, ministries, events, notifications, and church operations with ease."
                />
            </Helmet>

            <HelpDocHeader />
            <section className="px-6 py-8 max-w-6xl mx-auto">
                {HelpData.length === 0 ? (
                    <p className="text-center text-gray-500 text-sm">
                        No results found.
                    </p>
                ) : (
                    <div className="space-y-8">
                        {HelpData.map((section, idx) => (
                            <div
                                key={idx}
                                className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden"
                            >
                                <div className="bg-secondary text-white px-6 py-4">
                                    <h2 className="text-2xl font-semibold">
                                        {section.category}
                                    </h2>
                                </div>

                                <div className="p-6">
                                    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                        {section.tabs.map((tab, tabIdx) => (
                                            <li key={tabIdx}>
                                                <Link to={tab.link}>
                                                    <button
                                                        type="button"
                                                        className="w-full px-4 py-3 rounded-lg bg-secondary text-white font-medium text-sm shadow-md hover:opacity-90 transition-all duration-200 cursor-pointer"
                                                    >
                                                        {tab.title}
                                                    </button>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default Tutorial;